import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lemmikute jagamine

  <span style="color:#85c1dc;">**FI:**</span>
  Suosikkien jakaminen

  <span style="color:#85c1dc;">**RU:**</span>
  Поделитесь избранными
*/
/* @__NO_SIDE_EFFECTS__ */
const m1975 = msg(
  mf`Lemmikute jagamine`,
  mf`Suosikkien jakaminen`,
  mf`Поделитесь избранными`,
)

export { m1975 as 'w.wishlist.share.title' }